import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { DatePicker, message, TimePicker } from 'antd';
import dayjs from 'dayjs'; // ✅ use dayjs instead of moment

const CollectionTimeModal = ({ isVisible, setIsVisible, setShows, setdateTime, cTime }) => {
  const [date, setDate] = useState(null);
  const [time, setTime] = useState(null);

  // ✅ Load initial values from cTime
  // useEffect(() => {
  //   if (cTime) {
  //     const parsed = dayjs(cTime);
  //     setDate(parsed);
  //     setTime(parsed);
  //   }
  // }, [cTime]);


   useEffect(() => {
     if (cTime) {
       const parsed = dayjs(cTime);
       setDate(parsed);
       setTime(parsed);
     } else {
       const now = dayjs();
       setDate(now);
       setTime(now);
     }
   }, [cTime]);
  const handleDateChange = (value) => {
    if (!value) {
      // if cleared, reset both fields
      setDate(null);
      // setTime(null);
    } else {
      setDate(value);
    }
  };
// console.log('date', date, cTime);
  const handleTimeChange = (value) => {
    if (!value) {
      // if cleared, reset both fields
      // setDate(null);
      setTime(null);
    } else {
      setTime(value);
    }
  };

  // ✅ Handle Save Action
  const handleSave = () => {
    if (date && time) {
      // new logic
      const selectedDateTime = dayjs(
        `${date.format('YYYY-MM-DD')} ${time.format('HH:mm:ss')}`
      );

      const now = dayjs();

      // ❌ Block future date/time (typed manually or selected)
      if (selectedDateTime.isAfter(now)) {
        message.warning('Future date/time is not allowed');
        return;
      }
      // ---------------------
      const finalDateTime = `${date.format('YYYY-MM-DD')} ${time.format('HH:mm:ss')}`;
      console.log('Collection Time Set:', finalDateTime);
      setdateTime(finalDateTime);
    } else {
      console.log('No valid date or time selected');
    }

    setIsVisible(false);
    setShows(true);
  };
  // Disable future dates
  const disabledDate = (current) => {
    return current && current > dayjs().endOf('day');
  };

  // Disable future time (only if selected date is today)
  const disabledTime = () => {
    const now = dayjs();

    // If selected date is NOT today → allow all time
    if (!date || !date.isSame(now, 'day')) {
      return {};
    }

    return {
      disabledHours: () =>
        Array.from({ length: 24 }, (_, i) => i).filter(
          (hour) => hour > now.hour()
        ),

      disabledMinutes: (selectedHour) =>
        selectedHour === now.hour()
          ? Array.from({ length: 60 }, (_, i) => i).filter(
            (minute) => minute > now.minute()
          )
          : [],

      disabledSeconds: (selectedHour, selectedMinute) =>
        selectedHour === now.hour() &&
          selectedMinute === now.minute()
          ? Array.from({ length: 60 }, (_, i) => i).filter(
            (second) => second > now.second()
          )
          : [],
    };
  };

  return (
    <div>
      {isVisible && (
        <Modal show={isVisible} onHide={() => setIsVisible(false)} size='lg' aria-labelledby='contained-modal-title-vcenter' centered>
          <Modal.Header closeButton>
            <Modal.Title id='contained-modal-title-vcenter'>Set Collection Time</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', alignItems: 'center' }}>
              <label>Collection Date :</label>
              <DatePicker format='YYYY-MM-DD' value={date} onChange={handleDateChange} allowClear style={{ width: '50%' }} getPopupContainer={(triggerNode) => triggerNode.parentNode} />
              <label>Collection Time :</label>
              <TimePicker format='HH:mm:ss' value={time} onChange={handleTimeChange} allowClear style={{ width: '50%' }} getPopupContainer={(triggerNode) => triggerNode.parentNode} />
            </div> */}

            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', width: '100%' }}>
              {/* Date */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <label style={{ flex: '0 0 150px', fontWeight: 500 }}>Collection Date :</label>
                {/* <DatePicker format='YYYY-MM-DD' value={date} onChange={handleDateChange} allowClear style={{ flex: 1 }} getPopupContainer={(triggerNode) => triggerNode.parentNode} /> */}
                <DatePicker format='MM-DD-YYYY' value={date} onChange={handleDateChange}
                  disabledDate={disabledDate}  
                  allowClear style={{ flex: 1 }} getPopupContainer={(triggerNode) => triggerNode.parentNode} />
              </div>

              {/* Time */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <label style={{ flex: '0 0 150px', fontWeight: 500 }}>Collection Time :</label>
                <TimePicker format='HH:mm:ss' value={time} onChange={handleTimeChange}
                  disabledTime={disabledTime}  
                  allowClear style={{ flex: 1 }} getPopupContainer={(triggerNode) => triggerNode.parentNode} />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button className='col-lg-2 btn-style' variant='secondary' onClick={() => setIsVisible(false)}>
              Cancel
            </Button>
            <Button className='col-lg-2 btn-style' variant='primary' onClick={handleSave}>
              Save
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
};

export default CollectionTimeModal;

// import React, { useState, useEffect } from 'react';
// import { DatePicker, Button } from 'antd';
// import dayjs from 'dayjs';

// // Example: server-provided value
// const cTime = '2025-08-03T20:43:48.000Z';

// const DateSelector = () => {
//   const [date, setDate] = useState(null);

//   // ✅ set initial date when cTime is available
//   useEffect(() => {
//     if (cTime) {
//       setDate(dayjs(cTime));
//     }
//   }, []);

//   const handleChange = (value) => {
//     setDate(value);
//   };

//   const handleReset = () => {
//     setDate(null);
//   };

//   return (
//     <div style={{ padding: '20px', maxWidth: '300px' }}>
//       <DatePicker format='YYYY-MM-DD' value={date} onChange={handleChange}
//         allowClear getPopupContainer={(triggerNode) => triggerNode.parentNode} style={{ width: '100%' }} />

//       <div style={{ marginTop: '10px' }}>
//         <Button onClick={handleReset}>Reset</Button>
//       </div>
//     </div>
//   );
// };

// export default DateSelector;

// import React, { useState, useEffect } from 'react';
// import { DatePicker, TimePicker, Button, Modal } from 'antd';
// import dayjs from 'dayjs';

// const cTime = '2025-08-03T20:43:48.000Z';

// const CollectionTimeModal = ({ isVisible, onClose }) => {
//   const [date, setDate] = useState(null);
//   const [time, setTime] = useState(null);

//   // ✅ Load initial values from cTime
//   useEffect(() => {
//     if (cTime) {
//       const parsed = dayjs(cTime);
//       setDate(parsed);
//       setTime(parsed);
//     }
//   }, []);

//   const handleDateChange = (value) => {
//     setDate(value);
//   };

//   const handleTimeChange = (value) => {
//     setTime(value);
//   };

//   const handleReset = () => {
//     setDate(null);
//     setTime(null);
//   };

//   return (
//     <Modal
//       title='Select Date & Time'
//       isVisible={isVisible}
//       onCancel={onClose}
//       footer={[
//         <Button key='reset' onClick={handleReset}>
//           Reset
//         </Button>,
//         <Button key='close' type='primary' onClick={onClose}>
//           Close
//         </Button>,
//       ]}
//     >
//       <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
//         <DatePicker format='YYYY-MM-DD' value={date} onChange={handleDateChange} allowClear style={{ width: '100%' }} getPopupContainer={(triggerNode) => triggerNode.parentNode} />

//         <TimePicker format='HH:mm:ss' value={time} onChange={handleTimeChange} allowClear style={{ width: '100%' }} getPopupContainer={(triggerNode) => triggerNode.parentNode} />
//       </div>
//     </Modal>
//   );
// };

// export default CollectionTimeModal;
